import React from 'react'

const Featured = () => {
  return (
    <div>Featured</div>
  )
}

export default Featured